// 初始化一个vuex的实例（数据仓库） 导出即可
import Vuex from 'vuex'
import Vue from 'vue'

// 使用安装
Vue.use(Vuex)

// 初始化
const store = new Vuex.Store({
  // 配置（state|mutations|actions）
    state: {
    // 管理数据
    count: 0
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js